export default __webpack_public_path__ + "static/media/V385MANC6.0581fe1d.pdf";